import React from 'react';
import { FiCalendar, FiClock, FiCheckCircle } from 'react-icons/fi';
import { workOrderService } from '../../../services/workOrderService';

const DetailTimeline = ({ workOrder }) => {
  if (!workOrder.timeline || workOrder.timeline.length === 0) {
    return (
      <div className="bg-[var(--bg-primary)] p-6 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
        <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-6 flex items-center space-x-2">
          <FiCalendar size={20} />
          <span>Timeline Pengerjaan</span>
        </h3>
        <p className="text-[var(--text-secondary)] text-center py-8">Belum ada aktivitas</p>
      </div>
    );
  }

  return (
    <div className="bg-[var(--bg-primary)] p-6 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
      <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-6 flex items-center space-x-2">
        <FiCalendar size={20} />
        <span>Timeline Pengerjaan</span>
      </h3>
      
      <div className="relative">
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-gray-300 dark:bg-gray-600 z-0 hidden md:block"></div>

        <div className="flex flex-wrap items-start justify-start gap-6 md:gap-8 lg:gap-12 relative">
          {workOrder.timeline.map((item, index) => {
            const isLast = index === workOrder.timeline.length - 1;
            const isCompleted = index < workOrder.timeline.length - 1;
            
            const statusKey = item.status || workOrder.status;
            const statusConfig = workOrderService.STATUS_FLOW?.[statusKey] || null;
            const isDelivered = statusKey === 'delivered';
            
            let IconComponent = FiClock;
            if (isCompleted || isDelivered) {
              IconComponent = FiCheckCircle;
            } else if (statusConfig?.icon) {
              try {
                const icons = require('react-icons/fi');
                IconComponent = icons[statusConfig.icon] || FiClock;
              } catch (e) {
                IconComponent = FiClock;
              }
            }
            
            const dotColor = (isCompleted || isDelivered)
              ? 'bg-green-500'
              : (statusConfig?.dotColor || 'bg-gray-500');
            
            const label = statusConfig?.label || item.status || statusKey;

            return (
              <div key={index} className="flex flex-col items-center relative group min-w-[80px] md:min-w-[100px]">
                <div className={`
                  w-10 h-10 md:w-11 md:h-11 rounded-full flex items-center justify-center 
                  ${dotColor}
                  shadow-md z-10 transition-all duration-300 hover:scale-110
                  border-2 border-white dark:border-gray-800
                `}>
                  <IconComponent className="text-white" size={14} />
                </div>
                
                <p className="text-[10px] md:text-xs font-semibold text-[var(--text-primary)] mt-2 text-center leading-tight">
                  {label}
                </p>
                
                <p className="text-[8px] md:text-[10px] text-[var(--text-secondary)] text-center mt-0.5 leading-tight">
                  {new Date(item.date).toLocaleDateString('id-ID', { 
                    day: '2-digit', 
                    month: 'short' 
                  })}
                  <br />
                  {new Date(item.date).toLocaleTimeString('id-ID', { 
                    hour: '2-digit', 
                    minute: '2-digit' 
                  })}
                </p>

                {item.note && (
                  <div className="mt-1 px-2 py-0.5 bg-gray-100 dark:bg-gray-800 rounded text-[8px] text-[var(--text-secondary)] text-center max-w-[100px] truncate">
                    "{item.note}"
                  </div>
                )}

                {item.duration && (
                  <div className="flex items-center gap-0.5 mt-0.5 text-[8px] md:text-[10px] text-gray-400 dark:text-gray-500">
                    <FiClock size={10} />
                    <span>{item.duration}</span>
                  </div>
                )}
                
                {item.changedBy && (
                  <p className="text-[8px] text-[var(--text-muted)] text-center mt-0.5">
                    {item.changedBy}
                  </p>
                )}

                {!isLast && (
                  <div className="absolute top-5 left-[calc(50%+20px)] right-[calc(-50%+20px)] z-0 hidden md:block">
                    <div className={`w-full h-0.5 border-t-2 border-dashed ${
                      isCompleted ? 'border-green-400/60' : 'border-gray-300/60'
                    }`} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DetailTimeline;